<template>
  <div class="message-board">
    <div class="board-header">Message Board</div>

    <div class="board-body">
      <van-loading v-if="loading" class="board-loading" color="#f0607f" />

      <div v-else-if="!list.length" class="board-empty">
        No messages yet.
      </div>

      <div v-else class="post-list">
        <div class="post-card" v-for="(item, index) in list" :key="item.id || index">
          <div v-if="item.displayDate" class="post-date">{{ item.displayDate }}</div>
          <div class="post-content">{{ item.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      list: [],
    };
  },
  methods: {
    normalizeList(data) {
      if (Array.isArray(data)) {
        return data;
      }
      if (data && typeof data === "object") {
        return Object.values(data);
      }
      return [];
    },
    formatMMDDYYYY(date) {
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    },
    resolvePublishDate(item, maxId) {
      const direct = String(
        item.date || item.publish_time || item.publishTime || ""
      ).trim();
      if (direct) {
        return direct;
      }

      const createTime =
        item.create_time || item.createTime || item.add_time || item.addTime;
      if (createTime) {
        const timestamp =
          typeof createTime === "number"
            ? createTime > 9999999999
              ? createTime
              : createTime * 1000
            : Date.parse(createTime);
        if (!Number.isNaN(timestamp)) {
          return this.formatMMDDYYYY(new Date(timestamp));
        }
      }

      if (item.id != null && maxId > 0) {
        const daysAgo = Math.max(0, maxId - Number(item.id));
        const date = new Date();
        date.setDate(date.getDate() - daysAgo);
        return this.formatMMDDYYYY(date);
      }

      return "";
    },
    mapMessageList(data) {
      const rawList = this.normalizeList(data).filter(
        (item) => item && item.content
      );
      const maxId = rawList.reduce(
        (max, row) => Math.max(max, Number(row.id) || 0),
        0
      );
      return rawList.map((item) => ({
        ...item,
        displayDate: this.resolvePublishDate(item, maxId),
      }));
    },
    getMessageList() {
      this.loading = true;
      this.$http({
        method: "get",
        url: "message_board_list",
      })
        .then((res) => {
          if (res && res.code === 200) {
            this.list = this.mapMessageList(res.data);
            return;
          }
          this.list = [];
          if (res && res.msg) {
            this.$toast.fail(res.msg);
          }
        })
        .catch(() => {
          this.list = [];
          this.$toast.fail("Failed to load messages");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getMessageList();
  },
};
</script>

<style lang="less" scoped>
*,
:after,
:before {
  box-sizing: border-box;
}

.message-board {
  min-height: 100vh;
  background: #f1f2f6;
  padding-bottom: calc(96px + env(safe-area-inset-bottom, 0px));
}

.board-header {
  position: sticky;
  top: 0;
  z-index: 10;
  text-align: center;
  font-size: 36px;
  font-weight: 700;
  color: #333;
  background: #f7f7fb;
  padding: 28px 0;
  border-bottom: 1px solid #e8e8ee;
}

.board-body {
  padding: 24px 20px 0;
}

.board-loading {
  display: block;
  text-align: center;
  margin-top: 80px;
}

.board-empty {
  text-align: center;
  color: #999;
  font-size: 28px;
  margin-top: 80px;
}

.post-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.post-card {
  background: #fff;
  border-radius: 20px;
  padding: 28px 26px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
}

.post-date {
  font-size: 28px;
  font-weight: 700;
  color: #2b2b2b;
  margin-bottom: 16px;
}

.post-content {
  font-size: 27px;
  line-height: 1.7;
  color: #5b8a86;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
